import AssetFormWrapper from "../../components/asset-forms/AssetFormWrapper";

/**
 * Crypto Asset Edit View
 * Now uses the unified AssetFormWrapper component
 */
const CryptoView = ({ assetId, startInEditMode }) => {
  return (
    <AssetFormWrapper
      mode="edit"
      subCategory="crypto"
      assetId={assetId}
      startInEditMode={startInEditMode}
    />
  );
};

export default CryptoView;
